// extracted by mini-css-extract-plugin
module.exports = {"boxContato":"Contato_boxContato__37vSg","descContato":"Contato_descContato__1FIkR","contatoDesc":"Contato_contatoDesc__3Du1o"};